import * as React from "react";
import { cn } from "~/lib/utils";

type BottomSheetTitleProps = React.HTMLAttributes<HTMLHeadingElement>;

export function BottomSheetTitle({ className, ...props }: BottomSheetTitleProps) {
  return (
    <h2 data-slot="bottom-sheet-title" className={cn("text-2xl font-semibold text-foreground", className)} {...props} />
  );
}
